module.exports = __webpack_public_path__ + "__static/site-1749741178941/img/asset_fiscal.a3ed015d.png";